import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import * as Styled from 'shiftNotes/styles/NotesStack.style';

interface NoteTranslationToggleProps {
  showingOriginal: boolean;
  onToggle: () => void;
}

export default function NoteTranslationToggle({
  showingOriginal,
  onToggle,
}: NoteTranslationToggleProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');
  const label = showingOriginal
    ? t('noteTranslation.showTranslation')
    : t('noteTranslation.showOriginal');

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onToggle();
  };

  return (
    <Styled.TranslationToggle
      type="button"
      onMouseDown={(event) => event.preventDefault()}
      onClick={handleClick}
      aria-label={label}
    >
      <General.Translate01 />
      {label}
    </Styled.TranslationToggle>
  );
}
